import { defineCustomElement } from "../chunks/vidstack-D9mvYVIz.js";
import { MediaPlayerElement, MediaProviderElement } from "../chunks/vidstack-CJk_aG_V.js";
//#region src/elements/bundles/player.ts
defineCustomElement(MediaPlayerElement);
defineCustomElement(MediaProviderElement);
//#endregion
